/* eslint-disable max-classes-per-file */
import { logger } from '../util/logger';
var ToastType;
(function (ToastType) {
    ToastType["Alert"] = "alert";
    ToastType["Confirm"] = "confirm";
    ToastType["Neutral"] = "neutral";
})(ToastType || (ToastType = {}));
class Toaster {
    toasts = {};
    settings;
    constructor(settings) {
        this.settings = settings || {};
        document.addEventListener('DOMContentLoaded', () => {
            this.doToastWrapOffset(document.querySelector('.js-head'));
            window.addEventListener('scroll', () => {
                this.doToastWrapOffset(document.querySelector('.js-head'));
            });
        });
    }
    // eslint-disable-next-line class-methods-use-this
    doToastWrapOffset = (head) => {
        const toastWrap = document.querySelector('.js-toast-wrap');
        if (toastWrap) {
            toastWrap.style.top = `${Math.max(head.offsetHeight - window.pageYOffset, 0)}px`;
        }
    };
}
const toaster = new Toaster();
class Toast {
    id;
    $outer;
    $text;
    $close;
    settings;
    DISPLAY_TIME;
    hideTimer;
    constructor(id, settings) {
        toaster.toasts[id] = this;
        this.settings = settings || {};
        this.id = id;
        this.$outer = document.getElementById(`${this.id}`);
        this.$text = this.$outer?.querySelector('.js-text');
        this.$close = this.$outer?.querySelector('.js-close');
        this.DISPLAY_TIME = 7000;
        this.hideTimer = null;
        if (!this.settings.type || Object.values(ToastType).indexOf(this.settings.type) < 0) {
            logger.log(`invalid "type" specified for Toast, ${this.id}. Valid types are "alert", "neutral", and "confirm"`);
            return;
        }
        document.addEventListener('DOMContentLoaded', () => {
            this.updateElements();
            this.$close.addEventListener('click', () => {
                this.hide();
            });
        });
    }
    hide = () => {
        if (this.$outer) {
            this.$outer.classList.remove('animate');
            this.$outer.classList.remove('is-showing');
        }
        const eventName = `toast${this.id}`;
        const event = new Event(eventName);
        window.removeEventListener(eventName, event);
    };
    startHideTimer = (displayTime) => {
        if (displayTime === null) {
            return;
        }
        let t = this.DISPLAY_TIME;
        if (parseInt(displayTime, 10) > 0) {
            t = parseInt(displayTime, 10);
        }
        this.hideTimer = setTimeout(() => {
            this.hide();
        }, t);
    };
    cancelHideTimer = () => {
        clearTimeout(this.hideTimer);
    };
    updateElements = () => {
        this.$outer = document.querySelector(`#${this.id}`);
        this.$text = this.$outer?.querySelector('.js-text');
        this.$close = this.$outer?.querySelector('.js-close');
    };
    show = (msg, displayTime) => {
        if (!msg) {
            throw new Error('No message defined for Toast');
        }
        this.cancelHideTimer();
        this.updateElements();
        this.$outer?.classList.add('is-showing', 'animate');
        this.$text.innerHTML = msg;
        this.startHideTimer(displayTime);
    };
}
const alertToast = new Toast('alertToast', {
    type: ToastType.Alert
});
const confirmToast = new Toast('confirmToast', {
    type: ToastType.Confirm
});
const neutralToast = new Toast('neutralToast', {
    type: ToastType.Neutral
});
export { alertToast, confirmToast, neutralToast };
